export default "##### Welcome to Carma<br />{name}\n\nWe’ve successfully created your account.\n\nRedirecting you to back to Carma in {second}.\n";